<app-input-header [labelKey]="outsideLabel ? labelKey : null" [required]="required" [reset]="changed()" (onReset)="reset()">
</app-input-header>
<div class="row-4">
  <mat-form-field appearance="outline" class="full-width background-white">
    <mat-select [(ngModel)]="selectedCountry" [disabled]="disabled || !!fixedCountry">
      <mat-select-trigger>
        <ng-container *ngTemplateOutlet="countryCode; context: { data: selectedCountry }"></ng-container>
      </mat-select-trigger>
      <mat-option *ngFor="let data of countries; let i = index" [value]="data">
        <ng-container *ngTemplateOutlet="countryCode; context: { data: data }"></ng-container>
        <hr *ngIf="showCountryDivider(i)" />
      </mat-option>
    </mat-select>
    <ng-template #countryCode let-data="data">
      <span class="flag-icon margin-right-5 flag-icon-{{ data.twoLetterCode | lowercase }}"></span>
      <span>{{ data.twoLetterCode }} +({{ data.countryCode }})</span>
    </ng-template>
  </mat-form-field>
  <mat-form-field appearance="outline" class="full-width background-white">
    <input
      class="phone-input"
      appPhoneMask
      [(ngModel)]="localNumber"
      [twoLetterCode]="selectedCountry?.twoLetterCode ?? 'PL'"
      [disabled]="disabled"
      matInput
      [placeholder]="labelKey | locLabel"
      autocomplete="off"
    />
  </mat-form-field>
</div>
<app-input-footer *ngIf="footer" [control]="ngControl?.control"></app-input-footer>
